export type ThemeThickness = "thin" | "bold";

/** The 7-field JSON shape stored in RDS's `app_settings.gp_widget.css` for a custom theme. */
export interface CustomThemeInput {
  main_tab: string;
  inactive_tab: string;
  realtime_bg: string;
  content_text: string;
  content_text_strong: string;
  prediction_bg: string;
  thickness: ThemeThickness;
}

export const BUILT_IN_THEME_NAMES = [
  "light",
  "dark",
  "cleangreen",
  "coolblue",
  "easter",
  "redhot",
  "graybreeze",
  "minimalwarmth",
] as const;

export type BuiltInThemeName = (typeof BUILT_IN_THEME_NAMES)[number];

/**
 * The 30-key token set from VIBE_CODE_PLAN.md's Appendix B, minus `affiliate_bg`/
 * `affiliate_text` — the plan explicitly allows dropping those since ads are out of scope,
 * and no derivation rule for them is actually given anywhere in Appendix B's formula.
 */
export interface ThemeTokens {
  tab_bg: string;
  tab_active_bg: string;
  tab_text: string;
  tab_active_text: string;
  realtime_bg: string;
  availability_border: string;
  realtime_inner_border: string;
  realtime_small_text: string;
  realtime_big_text: string;
  realtime_category_text: string;
  realtime_total_bg: string;
  realtime_total_text: string;
  prediction_bg: string;
  prediction_border: string;
  prediction_text: string;
  prediction_gauge_title: string;
  prediction_gauge_percentage: string;
  prediction_gauge: string;
  prediction_gauge_topring: string;
  realtime_powered_by_gymplus: string;
  weekdayrow_bg: string;
  weekdayrow_border: string;
  weekdayrow_text: string;
  weekdayrow_active_bg: string;
  weekdayrow_active_text: string;
  chart_bg: string;
  chart_border: string;
  chart_powered_by_gymplus: string;
  thickness: ThemeThickness;
}

export interface ThemeSizeTokens {
  borderWidth: number;
  borderRadius: number;
  fontWeight: number;
  fontWeightBold: number;
  textTransform: "uppercase";
  rtTotalPadding: string;
}
